<template>
	<div class="xiangmu">

		<breadcrumb :routerList="[{to:'/dingd/pm',title:'询价报价'},{title:'历史报价库'}]" style="width:100%" />

		<div class="h-piece h-mrt30">
			<div class="h-formBox">
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<el-form-item label="产品大类" style="margin-right: 40px;">
						<el-select v-model="formInline.dingdan" placeholder="模糊搜索" style="width:3.2rem">
							<el-option label="客户一" value="1"></el-option>
							<el-option label="客户二" vakue="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单编号"  style="margin-right: 40px;">
						<el-select v-model="formInline.dingdan" placeholder="请选择" style="width:2.2rem">
							<el-option label="客户一" value="1"></el-option>
							<el-option label="客户二" vakue="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单编号">
						<el-select v-model="formInline.dingdan" placeholder="请选择" style="width:2.55rem">
							<el-option label="客户一" value="1"></el-option>
							<el-option label="客户二" vakue="2"></el-option>
						</el-select>
					</el-form-item>
					
				</el-form>
				<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					<el-form-item label="产品编码"  style="margin-right: 40px;">
						<el-select v-model="formInline.customerName" placeholder="请选择" style="width:2rem">
							<el-option label="客户一" bianma=""></el-option>
							<el-option label="客户二" bianma=""></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="付款方式"  style="margin-right: 40px;">
						<el-select v-model="formInline.type" placeholder="请选择" style="width:1.5rem">
							<el-option label="类别1" value="1"></el-option>
							<el-option label="类别2" value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="报价时间"  style="margin-right: 40px;">
						<el-col :span="10">
						  <el-date-picker :clearable="false" type="date" placeholder="选择时间" value-format="yyyy-MM-dd" style="width: 1.6rem; margin-right: 40px;"></el-date-picker>
						</el-col>
						<el-col class="line h-txtCenter" :span="4">至</el-col>
						<el-col :span="10">
						  <el-date-picker :clearable="false" type="date" placeholder="选择时间" value-format="yyyy-MM-dd" style="width: 1.6rem;"></el-date-picker>
						</el-col>
					</el-form-item>
					<el-form-item class="h-formBtnOut">
						<el-button class="h-btn h-formBtn">检索</el-button>
						<el-button class="h-btn h-formBtn" @click="resetData">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="h-table h-mrt30" v-if="clickActive==1">
			<el-table :data="tableData2" @header-click="headerClick" style="width: 100%" border>
				<el-table-column type="selection" label="全选" width="70" >
				</el-table-column>
				<el-table-column type="index" label="#" width="40">
				</el-table-column>
				<el-table-column prop="customerName" label="产品大类" width="110" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="visitTime" label="物料编码" width="190" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="contact" label="询价状态" width="110">
				</el-table-column>
				<el-table-column prop="objective" label="询价数量" width="100">
				</el-table-column>
				<el-table-column prop="category" label="报价供应商" width="290" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="status" label="可用库存" width="115" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="category" label="付款方式" width="270" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="category" label="创建时间" width="200" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="category" label="创建时间" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
			<div class="h-tableB h-mrt30">
				<div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;">批量导入</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>
				</div>
				<div class="h-pagination2">
					<span class="h-pagiLabel">显示数量:</span>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="4" :page-sizes="[10, 20, 30, 40]"
					 :page-size="10" layout="sizes, prev, pager, next,jumper" :total="400">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				//表单
				all: '全部',
				formInline: {
					dingdan: '',
					customerName: '',
					date3: '',
					type: '',
					value: '',
					bianma: ''
				},
				//表格
				multipleSelection: [],
				tableData2: [{
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: 'SJHS;LT348',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}],
				clickActive: 1
			}
		},
		methods: {
			// 重置按钮
			resetData() {
				this.formInline.dingdan = ""
				this.formInline.customerName = ""
				this.formInline.type = ""
				this.$message({
					type: "success",
					message: '已成功重置'
				});
			}
		},
		mounted() {
			this.lineChart();
		},
	}
</script>
<style scoped>
	.xiangmu>.h-piece,.h-mrt30 {
		margin: 20px;
	}
	.h-formBtnOut {
		float: right;
	}
	.el-form::after {
		content: '';
		width: 0;
		height: 0;
		clear: both;
		display: block;
	}
</style>
